import { env } from '@/config/env'

/**
 * Format a numeric price for display.
 * @param {number} amount
 * @param {Object} [opts]
 * @param {boolean} [opts.withSymbol]
 */
export function formatPrice(amount, { withSymbol = true } = {}) {
  const num = Math.round(Number(amount) || 0)
  const formatted = num.toLocaleString('en-BD')
  return withSymbol ? `${env.currencySymbol}${formatted}` : formatted
}
